import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import unifiedAuthManager from '../services/unifiedAuthManager';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthed = unifiedAuthManager.isAuthenticated();
  const userRoles = unifiedAuthManager.getUserRoles();
  const currentUser = unifiedAuthManager.getUnifiedUser();  

  console.log("ProtectedRoute - User Roles:", userRoles);
  console.log("ProtectedRoute - Current User:", currentUser);
  console.log("ProtectedRoute - Current Path:", location.pathname);

  // Check if user is not authenticated
  if (!isAuthed) {
    // If trying to access job-recommendations, redirect to resume-login
    if (location.pathname === '/job-recommendations') {
      return <Navigate to="/resume-login" replace state={{ from: location }} />;
    }
    // Otherwise redirect to regular login
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // User is authenticated - check their role
  const isCandidate = userRoles.some(role => 
    role.toLowerCase().includes('role_candidateuser')
  );

  const isRecruiterOrAdmin = userRoles.some(role => 
    role.toLowerCase().includes('role_admin') || 
    role.toLowerCase().includes('role_recruiter')
  );

  const isHrole = userRoles.some(role => 
    role.toLowerCase().includes('role_hr')
  );

  // Define candidate-only routes (these are the ONLY routes candidates can access)
  const candidateOnlyRoutes = [
    '/job-recommendations',
    '/consent',
    '/profiler'  // Added /profiler to candidate-only routes
  ];

  const ishrnotallowedroutes = [  
    '/job-recommendations',
    '/consent',
    '/profiler',
    '/adminDashboard'
  ];

  // Define routes that start with /opportunities (dynamic routes)
  const isOpportunityRoute = location.pathname.startsWith('/opportunities');

  // Check if current path is a candidate-only route
  const isOnCandidateOnlyRoute = candidateOnlyRoutes.some(route => 
    location.pathname.startsWith(route)
  ) || isOpportunityRoute;

 const isOnhrnotallowedroute = ishrnotallowedroutes.some(route => 
    location.pathname.startsWith(route)
  ) || isOpportunityRoute;

  // CANDIDATE LOGIC: Candidates can ONLY access candidate routes
  if (isCandidate) {
    console.log("Candidate access check");
    // Block candidates without resume_id from accessing /profiler
    if (location.pathname.startsWith('/profiler') && !currentUser?.resume_id) {
      console.log("Redirecting candidate without resume to job recommendations"); 
      return <Navigate 
        to={`/job-recommendations?candidateId=${currentUser.candidate_id}`} 
        replace 
      />;
    }
    
    // If candidate is trying to access a non-candidate route, redirect to job recommendations
    if (!isOnCandidateOnlyRoute) {
      return <Navigate 
        to={`/job-recommendations?candidateId=${currentUser.candidate_id}`} 
        replace 
      />;
    }
    // Candidate is on a valid candidate route - allow access
    return children;
  }

  // RECRUITER/ADMIN LOGIC: Recruiters/Admins can access everything EXCEPT candidate-only routes
  if (isRecruiterOrAdmin) {
    console.log("Recruiter/Admin access check");
    // If recruiter/admin is trying to access candidate-only routes, redirect to dashboard
    if (isOnCandidateOnlyRoute ) {
      return <Navigate to="/adminDashboard" replace />;
    }
    // Recruiter/Admin can access any other route - allow access
    return children;
  }

  if(isHrole){  
   console.log("HR access check");
     if (isOnhrnotallowedroute) {
      return <Navigate to="/recruiterDashboard" replace />;
    }
  }



  // Fallback - if authenticated but no recognized role, allow access
  return children;
};

export default ProtectedRoute;